import { Box } from '@mui/material';

import { neutrals, common } from '@toolbox/style/theme/common/ThemeProvider/colors';

export const Separator = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '300px',
        color: neutrals.light,
        fontSize: '12px',
        lineHeight: 2,
        position: 'relative',
        margin: '16px 36px 16px 0',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          top: '50%',
          borderTop: `1px solid ${neutrals.light}`,
        },
      }}
    >
      <Box
        sx={{
          padding: '0 8px',
          backgroundColor: common.white,
          zIndex: 1,
        }}
      >
        Oder
      </Box>
    </Box>
  );
};
